import React, { PropTypes } from 'react';
import { Paper, FlatButton } from 'material-ui';

const ContractingCardIntro = (props) => {
  const {
    goStartNewContract,
    user,
  } = props;
  const userType = user.user.type;

  const contractorBlurb = (
    <div>
      <p style={{ fontSize: '16px', marginBottom: '3%', color: 'rgba(0, 0, 0, 0.54)' }}>
        You need rates and a few other details from your suppliers, so you have everything you need to book their products. We use contracts to hold all of this information.
      </p>
      <p style={{ fontSize: '16px', color: 'rgba(0, 0, 0, 0.54)' }}>Use TourConnect to request your supplier rates. Once you've requested rates from your partners, you can:</p>
      <ul style={{ fontSize: '16px', padding: '3% 5% 5% 5%' }}>
        <li style={{ fontSize: '16px' }}>Review, comment, and accept rates provided via TourConnect contracts</li>
        <li style={{ fontSize: '16px' }}>Store and manage rates sent in other formats (spreadsheet, pdf, word document, etc.)</li>
        <li style={{ fontSize: '16px' }}>Automatically load rates into your booking system using our API</li>
      </ul>
    </div>
  );

  const supplierBlurb = (
    <div>
      <p style={{ fontSize: '16px', marginBottom: '3%', color: 'rgba(0, 0, 0, 0.54)' }}>
        In order for your partners to sell your products, they need your rates and a few other details. We use contracts to hold all of this information.
      </p>
      <p style={{ fontSize: '16px', color: 'rgba(0, 0, 0, 0.54)' }}>Use TourConnect to send these contracts to your partners. Once you've finished your first contract, you can:</p>
      <ul style={{ fontSize: '16px', padding: '3% 5% 5% 5%' }}>
        <li style={{ fontSize: '16px' }}>Save your rates and details to use at a later time</li>
        <li style={{ fontSize: '16px' }}>Send your rates to anyone in the world</li>
      </ul>
    </div>
  );
  const flatButtonLabel = userType === 'Supplier' ? 'Start a New Contract' : 'Request Supplier Rates';

  return (
    <div>
      <Paper style={{ width: '50%', margin: 'auto', position: 'relative', clear: 'both', overflow: 'hidden' }}>
        <div style={{ position: 'relative', backgroundColor: '#00bcd4', color: '#fff', padding: '18px', paddingTop: '25%' }}>
          <span style={{ position: 'relative', fontSize: '22px' }}>Exchange rates with your partners</span>
        </div>
        <div style={{ padding: '3%' }}>
          {userType === 'Supplier' ? supplierBlurb : contractorBlurb}
          <FlatButton
            label={flatButtonLabel}
            onTouchTap={goStartNewContract}
            secondary
            style={{ float: 'right', display: 'block', position: 'relative', marginBottom: '2%' }}
          />
        </div>
      </Paper>
    </div>
  );
};

ContractingCardIntro.propTypes = {
  goStartNewContract: PropTypes.func,
  user: PropTypes.object,
};

export default ContractingCardIntro;



// WEBPACK FOOTER //
// ./src/app/components/contracting/card-intro.jsx